import {useEffect, useRef} from 'react';
import {aiStore} from "../index";
import Settings from "../settings.json";

const iframeOrigin = new URL(Settings.iframeUrl).origin;

export const useIframeMessenger = ({onMessage, isTestMode}) => {
    const iframeRef = useRef(null);

    const sendMessage = (message) => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            iframeRef.current.contentWindow.postMessage(message, iframeOrigin);
        }
    };

    useEffect(() => {
        const handleMessage = async (event) => {
            if (event.origin !== iframeOrigin) return;
            if (!event.data?.functionName) return;

            if (aiStore.isTestChatOpen === isTestMode) {
                const result = await aiStore[event.data.functionName]?.(event.data.functionInput);

                if (event.data.id && iframeRef.current) {
                    iframeRef.current.contentWindow.postMessage({
                        functionName: 'encapsulateResponse',
                        functionInput: result,
                        id: event.data.id,
                    }, iframeOrigin);
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [onMessage, isTestMode]);

    return {
        iframeRef,
        sendMessage,
    };
};